import PrimaryLayout from './primary'
import HistoriaLayout from './historia'

export { HistoriaLayout }

export default PrimaryLayout
